import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { VolumeListParams, VolumeListResponse } from './types';

/** 可选云盘列表（dc/ws 由 URL 解析） */
export function getVolumeList(params?: VolumeListParams): Promise<VolumeListResponse> {
  const { namespace, ...restParams } = params || {};
  const base = PREFIX.vapis_v1_dc_ws(GROUPS.storageStack);
  if (namespace) {
    return get(`${base}/namespaces/${namespace}/volumes`, {
      ascending: false,
      ...restParams,
    });
  }
  return get(`${base}/volumes`, {
    ascending: false,
    ...restParams,
  });
}
